import clsx from "clsx";

type sizeIcon = "small" | "normal" | "medium" | "large" | "large-x";

interface INotFoundMessage {
    icon: string;
    title: string;
    subtitle?: string;
    sizeIcon?: sizeIcon;
    className?: string;
    classNameIcon?: string;
    classNameTitle?: string;
    classNameSubtitle?: string;
}

export function NotFoundMessage({ 
    icon, 
    title, 
    subtitle,
    sizeIcon,
    className,
    classNameIcon,
    classNameTitle,
    classNameSubtitle,
    }: INotFoundMessage) {
    return (
        <div className={clsx("flex flex-col w-full h-full justify-center text-center", className)}>
            <span className={clsx(`material-symbols-outlined text-[--grey-text-color] `, classNameIcon,
            {
                "!text-[24px]": sizeIcon === "small",
                "!text-[32px]": sizeIcon === "normal" || !sizeIcon,
                "!text-[40px]": sizeIcon === "medium",
                "!text-[48px]": sizeIcon === "large",
                "!text-[64px]": sizeIcon === "large-x",
            })}>
                {icon}
            </span>
            <strong className={clsx("text-lg text-[--light-color]", classNameTitle)}> 
                {title}
            </strong>
            <p className={clsx("text-[--grey-text-color]", classNameSubtitle)}>
                {subtitle}
            </p>
        </div>
    );
}